import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppSettings } from '../shared/Constants/sharedConstants';
import { CurrentTheme, ICurrentTheme } from '../shared/models/uiapp-config';

/**
 * The theme this page was served under. The server applies it - palette, splash, logo - when it
 * renders the page (SpaShellMiddleware), so it is fixed for the life of the page: switching to a
 * different theme, or picking up a saved change to this one, is a reload.
 */
@Injectable({
  providedIn: 'root',
})
export class ThemeSettingsService {
  themeConfig$ = new BehaviorSubject<ICurrentTheme>(
    AppSettings?.UIAppConfig?.currentTheme,
  );

  public currentTheme$: BehaviorSubject<CurrentTheme> =
    new BehaviorSubject<CurrentTheme>(
      this.themeConfig$.value?.themeName ? new CurrentTheme(this.themeConfig$.value) : null,
    );

  public themeEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
